// Color de identidad del módulo Caja Chica (El Alto) — mismo patrón que las otras Cajas.
export const CAJA_CHICA_EL_ALTO_COLOR = "#558b2f";
